import {useParams, useNavigate} from "react-router-dom";
import {Alert, Tag} from "antd";
import {Button, FontAwesomeIcon, Loading, PageHeader, ProjectToolNav} from "~/components";
import {useGetCrawlPageQuery} from "~/reduxs/api/crawlerApiSlice";
// Tái dùng nguyên component kết quả chấm điểm đơn trang (ScoreOverview + CrawlSummary
// + CriteriaGroup) từ eval_json đã lưu — không cần preview iframe cho crawler.
import SeoResult from "~/features/SeoCheck/components/SeoResult";

/**
 * Chi tiết SEO 1 trang trong crawl — nạp lại eval_json và render bằng SeoResult.
 */
function CrawlPageDetail() {

	const {id} = useParams();
	const navigate = useNavigate();

	const {data, isLoading} = useGetCrawlPageQuery(id);

	if (isLoading) return <Loading />;
	if (!data) return <div className="container">Không tìm thấy trang.</div>;

	return (
		<div className="container">
			{data.project_id > 0 && (
				<ProjectToolNav projectId={data.project_id} active="crawler"
					trail={[
						{label: `Crawl #${data.crawl_id}`, to: `/crawler/crawls/${data.crawl_id}`},
						{label: 'Chi tiết trang'},
					]} />
			)}

			<PageHeader
				icon="fa-light fa-file-magnifying-glass"
				title="Chi tiết trang"
				subtitle={data.url}
				actions={
					<Button white onClick={() => navigate(-1)}
						leftIcon={<FontAwesomeIcon icon="fa-light fa-arrow-left" />}>
						Quay lại
					</Button>
				}
			/>

			<div style={{marginBottom: 12}}>
				<Tag>HTTP {data.status_code}</Tag>
				<Tag>Depth {data.depth}</Tag>
			</div>

			{data.result ? (
				<SeoResult result={data.result} showPreview={false} />
			) : (
				<Alert type="warning" showIcon
					message="Không có dữ liệu chấm điểm"
					description="Trang này không tải được nội dung (không phải 2xx) nên không được phân tích chi tiết."
				/>
			)}
		</div>
	);
}

export default CrawlPageDetail;
